import React from 'react';

import { usePathname } from 'next/navigation';

import { withEventScope } from '@repo/event-processor';
import { IconButton } from '@repo/ui/components/Buttons';
import CloseIcon from '@repo/ui/components/Icon/CloseIcon';
import { themeStyle } from '@repo/ui/theming';

import { bannerStoreSelector, useBannerStore } from 'stores/bannerStore';
import { LayoutSwitch } from 'styles/queries';

import { Close, Text, Wrapper } from './styles';

const iconButtonTheme = {
  color: themeStyle.inkBase,
  activeColor: themeStyle.inkLight,
};
/**
 * A banner on the top of the page that can be used to inform
 * the user about something.
 */
const Banner: React.FC = () => {
  const close = useBannerStore(bannerStoreSelector.close);
  const storeItem = useBannerStore(bannerStoreSelector.item);
  const getItem = useBannerStore(bannerStoreSelector.getItem);

  const pathname = usePathname();

  const item = storeItem ? storeItem : getItem?.(pathname ?? '');

  const isLink = !!item?.href;

  return (
    <Wrapper
      alignItems="center"
      data-testid="banner"
      isLink={isLink}
      justifyContent="center"
      onClick={(): void => {
        if (isLink) {
          window.open(item?.href, '_blank');
        }
      }}
    >
      {item?.descriptionMobile ? (
        <LayoutSwitch
          desktopProps={{ children: item.description }}
          mobileProps={{ children: item.descriptionMobile }}
        >
          <Text id="banner-content" />
        </LayoutSwitch>
      ) : (
        <Text id="banner-content">{item?.description}</Text>
      )}
      <Close>
        <IconButton
          ariaLabel="close"
          height="10px"
          icon={CloseIcon}
          name="closeBannerButton"
          theme={iconButtonTheme}
          onClick={(e): void => {
            e.stopPropagation();
            close();
          }}
        />
      </Close>
    </Wrapper>
  );
};
export default withEventScope(Banner, { module: 'banner' });
